import type { Schedule } from "../types";

export function getRoleOrders(schedule: Schedule, useNameAsKey: boolean = false): Map<string, number> {
    const roleOrders = new Map<string, number>();

    if (schedule?.roles) {
        schedule.roles.forEach((r: any) => {
            if (r.order !== undefined) {
                const key = useNameAsKey ? r.name : r.id;
                roleOrders.set(key, r.order);
            }
        });
    }

    return roleOrders;
}

export function sortRoles<T>(
    items: T[],
    roleOrders: Map<string, number>,
    getId: (item: T) => string,
    getName: (item: T) => string
): T[] {
    return items.sort((a, b) => {
        const idA = getId(a);
        const idB = getId(b);
        const orderA = roleOrders.get(idA) ?? Number.MAX_SAFE_INTEGER;
        const orderB = roleOrders.get(idB) ?? Number.MAX_SAFE_INTEGER;

        if (orderA !== orderB) {
            return orderA - orderB;
        }

        return getName(a).localeCompare(getName(b), undefined, { sensitivity: "base" });
    });
}
